import { useSyncExternalStore } from "react";

/*
 * Зажат ли Shift — как у Discord: состояние берётся из любого события с
 * клавиатуры и из движения мыши, а уход фокуса из окна его сбрасывает. Иначе
 * Shift, отпущенный в другом окне, так и считался бы зажатым.
 *
 * Слушатели вешаются на окно один раз, с первым подписчиком, и не снимаются:
 * Shift, зажатый ещё до наведения на строку, должен быть уже известен, а
 * обработчики пустые — дешевле держать их, чем вешать на каждое наведение.
 * Самый первый подписчик узнаёт о Shift со следующим движением мыши.
 */

let held = false;
let listening = false;
const watchers = new Set<() => void>();

function update(next: boolean) {
  if (next === held) return;
  held = next;
  for (const watcher of watchers) watcher();
}

function listen() {
  if (listening) return;
  listening = true;
  const onInput = (event: KeyboardEvent | MouseEvent) => update(event.shiftKey);
  window.addEventListener("keydown", onInput);
  window.addEventListener("keyup", onInput);
  window.addEventListener("mousemove", onInput);
  window.addEventListener("blur", () => update(false));
}

function subscribe(watcher: () => void): () => void {
  listen();
  watchers.add(watcher);
  return () => void watchers.delete(watcher);
}

/** Зажат ли Shift; `active` ложно — не следить и считать отпущенным. */
export function useShiftHeld(active = true): boolean {
  return useSyncExternalStore(active ? subscribe : noop, () => active && held);
}

function noop() {
  return () => {};
}
